import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useApi } from "../client";
import keys from "./keys";
import {
  AtmosphericData,
  ClimateDataGranularity,
  ClimateVariable,
  RainfallData,
} from "./types";

export const useRainfallData = ({
  areaId,
  from,
  to,
  granularity,
}: {
  areaId: string;
  from: string;
  to: string;
  granularity: ClimateDataGranularity;
}) => {
  const api = useApi();

  return useQuery({
    queryKey: keys.rainfall({ areaId, from, to, granularity }),
    queryFn: async (): Promise<RainfallData> => {
      const response = await api.get(`climate-data/${areaId}/rainfall`, {
        searchParams: { from, to, granularity },
      });
      return response.json();
    },
    placeholderData: keepPreviousData,
    retry: 0,
  });
};

/**
 * Données atmosphériques (température, irradiance, humidité).
 * Même route que la pluie, segment `:type` différent.
 */
export const useAtmosphericData = ({
  type,
  areaId,
  from,
  to,
  granularity,
}: {
  type: Exclude<ClimateVariable, "rainfall">;
  areaId: string;
  from: string;
  to: string;
  granularity: ClimateDataGranularity;
}) => {
  const api = useApi();

  return useQuery({
    queryKey: keys.atmospheric({ type, areaId, from, to, granularity }),
    queryFn: async (): Promise<AtmosphericData> => {
      const response = await api.get(`climate-data/${areaId}/${type}`, {
        searchParams: { from, to, granularity },
      });
      return response.json();
    },
    placeholderData: keepPreviousData,
    retry: 0,
  });
};
